import { useState } from "react";
import uiTextData from "../data/uiText";

const useUILanguage = () => {
  const [lang, setLang] = useState("en");

  return {
    lang,
    setLang,
    uiText: uiTextData[lang],
    toastText: uiTextData[lang].toast,
  };
};

export default useUILanguage;